var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeshBoardDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bar-chart-square-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M6.66667 11.4872V14.8205M13.3333 9.82051V14.8205M10 6.48717V14.8205M6.5 18.1538H13.5C14.9001 18.1538 15.6002 18.1538 16.135 17.8814C16.6054 17.6417 16.9878 17.2592 17.2275 16.7888C17.5 16.254 17.5 15.554 17.5 14.1538V7.15384C17.5 5.75371 17.5 5.05364 17.2275 4.51886C16.9878 4.04846 16.6054 3.66601 16.135 3.42632C15.6002 3.15384 14.9001 3.15384 13.5 3.15384H6.5C5.09987 3.15384 4.3998 3.15384 3.86502 3.42632C3.39462 3.66601 3.01217 4.04846 2.77248 4.51886C2.5 5.05364 2.5 5.75371 2.5 7.15384V14.1538C2.5 15.554 2.5 16.254 2.77248 16.7888C3.01217 17.2592 3.39462 17.6417 3.86502 17.8814C4.3998 18.1538 5.09987 18.1538 6.5 18.1538Z",
    stroke: "#676A73",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeshBoardDefault);
export default __webpack_public_path__ + "static/media/deshBoardDefault.d89942692e86766746f7f2af5ebd8b06.svg";
export { ForwardRef as ReactComponent };